module.exports = __webpack_public_path__ + "img/bg-banner-account.c93ac9d2.svg";